import type { IconData } from '@stacksjs/iconify-core'

export const googlePlayCircle: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/><path d=\"m14.335 9.61l-1.817-1.05l-1.495 1.446l1.366 1.322l1.946-1.124a.34.34 0 0 0 .172-.297a.34.34 0 0 0-.172-.298zM12.21 8.38l-2-1.155l-4.384-2.25l4.95 4.793zM5.9 14.966l4.317-2.382l1.864-1.077l-1.304-1.263zM5.534 5.17l-.005 9.677l5.002-4.841z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default googlePlayCircle
